<template>
  <v-dialog
    v-model="dialogModel"
    :width="$vuetify.breakpoint.mdAndUp ? '600px' : ''"
  >
    <v-card>
      <v-card-title
        :class="{
          'primary': type === 'edit',
          'accent--text': type === 'edit',
          'error': type === 'delete',
          'white--text': type === 'delete'
        }"
      >
        {{ title() }}
      </v-card-title>
      <v-card-text>
        <div
          class="my-5"
          v-html="description()"
        ></div>

        <v-btn
          rounded
          block
          outlined
          :color="type === 'delete' ? 'error' : 'primary'"
          class="mb-3"
          @click="$emit('confirm-future', type)"
        >
          All future shifts
        </v-btn>
        <v-btn
          rounded
          block
          outlined
          :color="type === 'delete' ? 'error' : 'primary'"
          class="mb-3"
          @click="$emit('confirm-one', type)"
        >
          Only this shift
        </v-btn>
        <v-btn
          rounded
          block
          outlined
          class="mb-3"
          @click="dialogModel = false"
        >
          Cancel
        </v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    model: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogModel: false
    }
  },
  watch: {
    'model': function() {
      this.dialogModel = !!this.model
      // If the model was closed, reset the loading
      if (this.dialogModel === false) {
        this.isLoading = false
        this.$emit('cancel')
      }
    },
    'dialogModel': function() {
      if (this.dialogModel === false) {
        this.isLoading = false
        this.$emit('cancel')
      }
    },
  },
  methods: {
    title() {
      let title = ''
      if (this.type === 'edit') {
        title = 'Edit recurring shift'
      } else if (this.type === 'delete') {
        title = 'Delete recurring shift'
      }
      return title
    },
    description() {
      let descr = ''
      if (this.type === 'edit') {
        descr = 'You are modifying a recurring shift. <br /> Do you want to change only this shift, or this and all future shifts? <br />'
      } else if (this.type === 'delete') {
        descr = 'You are deleting a recurring shift. <br /> Do you want to delete only this shift, or this and all future shifts? <br />'
      }
      return descr
    }
  }
}
</script>
